import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import { Dashboard, Auth } from "@/layouts";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicRoute from "./components/PublicRoute";
import { ToastContainer } from 'react-toastify';
import { NotFound } from './pages/errors/404';
import { Forbidden } from './pages/errors/403';
import { SocketProvider } from "./components/SocketContext.jsx";
import io from "socket.io-client";
import { useSelector } from 'react-redux';
import DeliveryAuth from "./layouts/delivery/delivery-auth";
import SignUp from "./pages/delivery/delivery-auth/sign-up";
import DeliveryDashboard from "./layouts/delivery/delivery-dashboard";
import { isDeliveryPartner } from "@/utils/userRoles";
import PublicPolicy from "./pages/public-pages/public-policy";
import { setAppLanguage } from "@/utils/language";

function App() {
  const { user } = useSelector((state) => state.user);
  const [socket, setSocket] = useState(null);
  const CHAT_URL = import.meta.env.VITE_CHAT_URL;

  useEffect(() => {
    if (!user?.id || !CHAT_URL) {
      return;
    }
    const sock = io(CHAT_URL, {
      query: { userId: user.id },
    });
    setSocket(sock);
    setAppLanguage(user?.language || 'en');
    return () => {
      sock.disconnect();
      setSocket(null);
    };
  }, [user?.id]);

  return (
    <SocketProvider socket={socket}>
      <Routes>
        <Route path="/*" element={<PublicRoute><Auth /></PublicRoute>} />
        {!isDeliveryPartner(user) && (
          <Route path="/dashboard/*" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        )}
        <Route path="/sign-up" element={<PublicRoute><DeliveryAuth><SignUp></SignUp></DeliveryAuth></PublicRoute>} />
        <Route path="/privacy-policy" element={<PublicRoute><DeliveryAuth><PublicPolicy type="privacy"></PublicPolicy></DeliveryAuth></PublicRoute>} />
        <Route path="/terms-conditions" element={<PublicRoute><DeliveryAuth><PublicPolicy type="terms"></PublicPolicy></DeliveryAuth></PublicRoute>} />
        {isDeliveryPartner(user) && (
          <Route path="/delivery-partner/*" element={<ProtectedRoute><DeliveryDashboard /></ProtectedRoute>} />
        )}
        <Route path="/404" element={<NotFound></NotFound>} />
        <Route path="/403" element={<Forbidden></Forbidden>} />
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
        style={{ zIndex: 99999 }}
      />
    </SocketProvider>
  );
}

export default App;
